// Donation Counter Vue Component
const DonationCounter = {
  setup() {
    const { createApp, computed, onMounted, ref } = Vue;
    const { totalWithGiftAid, loading, error, loadDonors, getCachedTotals } = window.donorStore;
    const additionalDonations = window.additionalDonations || 0;
    
    // Initialize with cached total if available
    const cachedTotal = ref(null);
    const cachedTotals = getCachedTotals();
    if (cachedTotals) {
      cachedTotal.value = cachedTotals.totalWithGiftAid;
    }

    // Format money helper
    const formatMoney = (amount) => {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    };

    // Computed total with additional donations
    const displayTotal = computed(() => {
      // Use cached total if available and data is still loading
      if (cachedTotal.value && loading.value) {
        return formatMoney(cachedTotal.value + additionalDonations);
      }
      // Otherwise use reactive total
      return formatMoney(totalWithGiftAid.value + additionalDonations);
    });

    // Only show an amount when we have a real total to display.
    // - If we have a cached total, show immediately
    // - If we don't have cache, wait until loading finishes and total > 0
    const shouldShowAmount = computed(() => {
      if (cachedTotal.value != null) return true;
      if (!loading.value) return true; // show after load completes, even if total is £0
      return false;
    });

    // Initialize data loading (but don't wait for it)
    onMounted(() => {
      // Load in background - this will update the reactive total when complete
      loadDonors().catch(err => {
        console.error('Background donor loading failed:', err);
      });
    });

    return {
      displayTotal,
      loading,
      error,
      shouldShowAmount
    };
  },
  
  template: `
    <div class='donation-counter'>
      <span class='total-amount' v-if="shouldShowAmount">
        <span>{{ displayTotal }}</span>
      </span>
    </div>
  `
};

// Auto-mount donation counter components
document.addEventListener('DOMContentLoaded', () => {
  const { createApp } = Vue;
  const donationCounters = document.querySelectorAll('.donation-counter-vue');
  
  donationCounters.forEach(element => {
    createApp(DonationCounter).mount(element);
  });
});